const ArrowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
      <path
        d="M2.5 4.32129L5 6.91388L7.5 4.32129H2.5Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
